import { useId } from "react";

const DraftRibbonIcon = ({ width = 84, height = 81, ...props }) => {
  const uid = useId().replace(/:/g, "");
  const clipId0 = `draft-ribbon-icon-clip0-${uid}`;
  const clipId1 = `draft-ribbon-icon-clip1-${uid}`;
  const maskId = `draft-ribbon-icon-mask-${uid}`;
  const gradientId = `draft-ribbon-icon-gradient-${uid}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 84 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId0})`}>
        <path
          d='M20 1L46.5811 1L71 25.7236V73C71 76.866 67.866 80 64 80L20 80C16.134 80 13 76.866 13 73V8C13 4.13401 16.134 1 20 1Z'
          fill='#F3F6FA'
          stroke='#D5D9DF'
          strokeWidth='2'
        />
        <path
          d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
          stroke='#D5D9DF'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <rect y='39' width='54' height='32' rx='4' fill='#146E37' />
      <path
        d='M12.1411 62L7.50043 62V48.9091L12.1794 48.9091C13.4962 48.9091 14.6297 49.1712 15.58 49.6953C16.5303 50.2152 17.2611 50.9631 17.7724 51.9389C18.2881 52.9148 18.5459 54.0824 18.5459 55.4418C18.5459 56.8054 18.2881 57.9773 17.7724 58.9574C17.2611 59.9375 16.526 60.6896 15.5672 61.2138C14.6126 61.7379 13.4706 62 12.1411 62ZM10.2682 59.6286L12.026 59.6286C12.8442 59.6286 13.5324 59.4837 14.0906 59.1939C14.6531 58.8999 15.075 58.446 15.3563 57.8324C15.6418 57.2145 15.7845 56.4176 15.7845 55.4418C15.7845 54.4744 15.6418 53.6839 15.3563 53.0703C15.075 52.4567 14.6553 52.005 14.097 51.7152C13.5388 51.4254 12.8506 51.2805 12.0324 51.2805L10.2682 51.2805V59.6286ZM20.6231 62V48.9091L25.7879 48.9091C26.7808 48.9091 27.6267 49.0987 28.3256 49.478C29.0244 49.853 29.5571 50.375 29.9236 51.044C30.2943 51.7088 30.4797 52.4759 30.4797 53.3452C30.4797 54.2145 30.2922 54.9815 29.9172 55.6463C29.5422 56.3111 28.9988 56.8288 28.2872 57.1996C27.5798 57.5703 26.7233 57.7557 25.7176 57.7557L22.4257 57.7557V55.5376L25.2702 55.5376C25.8028 55.5376 26.2417 55.446 26.5869 55.2628C26.9363 55.0753 27.1963 54.8175 27.3667 54.4893C27.5415 54.157 27.6288 53.7756 27.6288 53.3452C27.6288 52.9105 27.5415 52.5312 27.3667 52.2074C27.1963 51.8793 26.9363 51.6257 26.5869 51.4467C26.2375 51.2635 25.7943 51.1719 25.2574 51.1719L23.3909 51.1719V62L20.6231 62ZM32.3044 48.9091L35.7178 48.9091L39.3229 57.7045L39.4763 57.7045L43.0814 48.9091L46.4948 48.9091V62L43.8101 62V53.4794L43.7015 53.4794L40.3137 61.9361L38.4855 61.9361L35.0978 53.4474L34.9891 53.4474V62L32.3044 62V48.9091Z'
        fill='white'
      />
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits='userSpaceOnUse'
        x='12'
        y='0'
        width='60'
        height='81'
      >
        <g clipPath={`url(#${clipId1})`}>
          <path
            d='M20 1.5L46.373 1.5L70.5 25.9277V73C70.5 76.5899 67.5899 79.5 64 79.5L20 79.5C16.4101 79.5 13.5 76.5899 13.5 73V8C13.5 4.41015 16.4101 1.5 20 1.5Z'
            fill='#A8A8A8'
            stroke='#C5D0E1'
            strokeWidth='3'
          />
          <path
            d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
            stroke='#D5D9DF'
            strokeWidth='2'
            strokeLinecap='round'
          />
        </g>
      </mask>
      <g mask={`url(#${maskId})`}>
        <rect
          width='90'
          height='23.996'
          transform='translate(17.9202 -1.80945) rotate(40)'
          fill={`url(#${gradientId})`}
          fillOpacity='0.97'
        />
        <path
          d='M28.2115 26.4031L26.2823 24.7842L30.358 19.6626L32.2677 21.265C32.7835 21.6978 33.1475 22.1742 33.3597 22.6943C33.5748 23.214 33.6319 23.7512 33.5307 24.3059C33.4326 24.8602 33.1712 25.4042 32.7467 25.9377C32.3221 26.4712 31.8552 26.8441 31.3461 27.0563C30.8382 27.2669 30.3158 27.3179 29.7789 27.2094C29.2432 27.0991 28.7208 26.8304 28.2115 26.4031ZM28.5829 24.7461L29.1019 25.1816C29.35 25.3898 29.5939 25.5263 29.8335 25.5911C30.0748 25.6574 30.3208 25.6288 30.5714 25.5054C30.8236 25.3834 31.0917 25.144 31.3756 24.7872C31.6595 24.4305 31.8338 24.1123 31.8983 23.8328C31.9645 23.5547 31.9395 23.2988 31.8233 23.065C31.7088 22.8327 31.521 22.607 31.2598 22.3878L30.7799 21.9852L28.5829 24.7461ZM33.6368 30.9554L37.7125 25.8337L39.8768 27.6498C40.2489 27.962 40.5195 28.3044 40.6885 28.677C40.8575 29.0496 40.916 29.431 40.8641 29.8212C40.8122 30.2114 40.6416 30.5882 40.3524 30.9516C40.0605 31.3184 39.7344 31.5606 39.3741 31.6781C39.0155 31.797 38.6414 31.8001 38.252 31.6875C37.8642 31.5762 37.4793 31.3603 37.0974 31.0398L35.8047 29.9551L36.6644 28.8747L37.6829 29.7293C37.8429 29.8636 37.9951 29.9579 38.1395 30.0124C38.287 30.0666 38.4267 30.074 38.5587 30.0347C38.6924 29.9967 38.8169 29.9052 38.9324 29.7601C39.0491 29.6134 39.113 29.4682 39.1239 29.3244C39.1378 29.1804 39.1049 29.0388 39.0251 28.8995C38.9483 28.76 38.83 28.6232 38.67 28.4889L38.1901 28.0863L34.998 32.0976L33.6368 30.9554ZM38.4454 31.0698L37.8282 34.4724L36.3495 33.2316L36.996 29.8537L38.4454 31.0698ZM41.8426 37.8409L40.3737 36.6083L46.1044 32.8754L47.9651 34.4367L45.5445 40.9471L44.0755 39.7145L45.9319 35.0829L45.8928 35.0501L41.8426 37.8409ZM43.1764 35.5902L45.9381 37.9075L45.1102 38.9478L42.3485 36.6305L43.1764 35.5902ZM48.3255 43.2807L52.4012 38.159L55.9268 41.1173L55.0352 42.2377L52.8709 40.4216L52.1704 41.3019L54.1193 42.9372L53.2277 44.0575L51.2788 42.4223L49.6868 44.4229L48.3255 43.2807ZM57.6969 44.4711L58.5885 43.3507L62.9465 47.0075L62.0549 48.1279L60.5467 46.8624L57.3626 50.8637L56.0209 49.7379L59.2051 45.7366L57.6969 44.4711Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1='0'
          y1='11.998'
          x2='90'
          y2='11.998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C6C9CC' />
          <stop offset='1' stopColor='#6A7079' />
        </linearGradient>
        <clipPath id={clipId0}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
        <clipPath id={clipId1}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DraftRibbonIcon;
